//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    if (localStorage.getItem("accessibilityBannerDismissed") !== "true") {
      this.visible = true;
    }
  },
  methods: {
    dismiss() {
      this.visible = false;
      if (process.client) {
        localStorage.setItem("accessibilityBannerDismissed", "true");
      }
    },
  },
};
